export interface ProgressBarProps {
  color: string;
  progress: number;
  label: string;
}

export const ProgressBar = ({ color, progress, label }) => {
  return (
    <div className="w-full bg-gray-200 rounded-full h-[20px] relative">
      <div
        className={`text-md font-medium text-black text-center p-2 leading-none rounded-full h-full ${color}`}
        style={{ width: `${progress}%` }}
      >
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="text-md font-bold text-black">{label}</div>
        </div>
      </div>
    </div>
  );
};
export type ProgressBarData = {
  color: string;
  progress: number;
  label: string;
  labelLong: string;
};
export interface SectionedProgressProps {
  data: ProgressBarData[];
  totals: string;
}

export const SectionedProgressBar = ({
  data,
  totals,
}: SectionedProgressProps) => {
  return (
    <div className="w-full flex flex-col font-bold  items-center">
      {totals}
      <div className="w-full flex flex-row items-center bg-gray-200 outline outline-1 outline-gray-200 rounded-md h-[20px] relative">
        {data.map((section, index) => {
          return (
            <div
              key={section.label}
              className={`text-md font-medium text-black text-center items-center  pt-0.5 pl-2 leading-none rounded-md h-full`}
              style={{
                paddingLeft: index === 0 ? "0px" : "20px",
                marginLeft: index === 0 ? 0 : "-20px",
                zIndex: 100 - index,
                minWidth: "40px",
                width: `${section.progress}%`,
                backgroundColor: section.color,
              }}
            >
              <div
                className=" inset-0 flex items-center h-full justify-center "
                style={{}}
              >
                <div
                  className={`text-md items-center h-full font-semibold text-white `}
                >
                  {section.progress > 3
                    ? section.progress > 15
                      ? section.labelLong
                      : section.label
                    : ""}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProgressBar;
